import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_LAW_MATTERS = 'GET_LAW_MATTERS';
export const GET_LAW_MATTER = 'GET_LAW_MATTER';
export const CREATE_LAW_MATTER = 'CREATE_LAW_MATTER';
export const UPDATE_LAW_MATTER = 'UPDATE_LAW_MATTER';
export const DELETE_LAW_MATTER = 'DELETE_LAW_MATTER';

// Get all matters
export const getLawMatters = (filters) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawMatters(filters);

    dispatch({
      type: GET_LAW_MATTERS,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching law matters:', error);
    throw error;
  }
};

// Get single matter
export const getLawMatter = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawMatter(id);

    dispatch({
      type: GET_LAW_MATTER,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching law matter:', error);
    throw error;
  }
};

// Create matter
export const createLawMatter = (matterData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createLawMatter(matterData);

    dispatch({
      type: CREATE_LAW_MATTER,
      payload: data
    });

    if (openSnackbar) {
      openSnackbar('Matter created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Matter created successfully"));
    }

    return data;
  } catch (error) {
    console.error('Error creating matter:', error);
    if (openSnackbar) {
      openSnackbar(error.response?.data?.message || 'Error creating matter', SNACKBAR_DURATION_MS, getSnackbarColor("error.response?.data?.message Error creating matter"));
    }
    throw error;
  }
};

// Update matter
export const updateLawMatter = (id, matterData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateLawMatter(id, matterData);

    dispatch({
      type: UPDATE_LAW_MATTER,
      payload: data
    });

    if (openSnackbar) {
      openSnackbar('Matter updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Matter updated successfully"));
    }

    return data;
  } catch (error) {
    console.error('Error updating matter:', error);
    if (openSnackbar) {
      openSnackbar(error.response?.data?.message || 'Error updating matter', SNACKBAR_DURATION_MS, getSnackbarColor("error.response?.data?.message Error updating matter"));
    }
    throw error;
  }
};

// Delete matter
export const deleteLawMatter = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteLawMatter(id);

    dispatch({
      type: DELETE_LAW_MATTER,
      payload: id
    });

    if (openSnackbar) {
      openSnackbar('Matter deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Matter deleted successfully"));
    }
  } catch (error) {
    console.error('Error deleting matter:', error);
    if (openSnackbar) {
      openSnackbar(error.response?.data?.message || 'Error deleting matter', SNACKBAR_DURATION_MS, getSnackbarColor("error.response?.data?.message Error deleting matter"));
    }
    throw error;
  }
};
